module.exports = __webpack_public_path__ + "img/consultant.74337d09.png";